var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgMoonpot(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M430.3 376.4c-3.969-6.625-11.47-9.969-18.94-8.531c-47.34 9.094-95.81-3.391-132.9-34.08C241.3 303 219.1 257.7 219.1 209.5c0-57.83 31.25-111.5 81.5-140.2c6.688-3.781 10.19-11.16 8.938-18.75c-1.281-7.594-7-13.42-14.56-14.81C284.7 33.67 266.4 32 254.9 32C131.5 32 31.16 132.5 31.16 256s100.4 224 223.8 224c67.72 0 131.1-30.22 173.8-82.92C433.6 391.1 434.2 382.1 430.3 376.4zM416.3 386.1C376.6 435.9 317.8 464 254.9 464c-114.6 0-207.8-93.31-207.8-208s93.22-208 207.8-208c10.62 0 27.66 1.562 37.97 3.469c.9687 .1875 1.531 .7656 1.719 1.734c.1562 .9844-.1875 1.719-1.062 2.203c-55.25 31.5-89.59 90.55-89.59 154.1c0 53 23.44 102.8 64.28 136.6c40.78 33.77 94.13 47.44 146.1 37.47c1.062-.1562 1.844 .4375 2.219 1.016C417 385.4 416.1 386.2 416.3 386.1z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMoonpot);
export default __webpack_public_path__ + "static/media/moonpot.145ee909.svg";
export { ForwardRef as ReactComponent };